// biome-ignore lint/style/noRestrictedImports: this is the source of truth
import { styled as muiStyled, type Theme, type SxProps } from '@mui/material/styles';
import { CreateMUIStyled } from '@mui/system';
import { shouldForwardProp as muiShouldForwardProp } from '@mui/system/createStyled';
export { default as useMediaQuery } from '@mui/material/useMediaQuery';
export {
  css,
  keyframes,
  type ThemeOptions,
  createTheme,
  type ThemeProvider,
  useTheme,
  type Components
  // biome-ignore lint/style/noRestrictedImports: this is the source of truth
} from '@mui/material/styles';
export { Theme, SxProps };
export type Sx = SxProps<Theme>;

export const styled: CreateMUIStyled<Theme> = (tag: any, options?: any) => {
  const isHtmlTag = typeof tag === 'string';
  const targetOptions = {
    ...options,
    shouldForwardProp: (prop: string) => !prop.startsWith('$') && (!isHtmlTag || muiShouldForwardProp(prop))
  };
  return muiStyled(tag, targetOptions);
};
